import type { CreateTenantAdmin } from '@wf-coe/types';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';
import type { TenantAdminDto } from './use-tenant-admins.js';

interface CreateTenantAdminInput {
  clientId: string;
  body: CreateTenantAdmin;
}

/** Mutation for `POST /v1/clients/{clientId}/admins`. */
export function useCreateTenantAdminMutation(): UseMutationResult<
  TenantAdminDto,
  Error,
  CreateTenantAdminInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, body }: CreateTenantAdminInput) => {
      if (!api) throw new Error('useCreateTenantAdminMutation: api client unavailable');
      return api.post<TenantAdminDto>(`/v1/clients/${clientId}/admins`, body);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['tenant-admins', clientId] });
    },
  });
}
